import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';

import { FeatureToggle, routes } from '@fly/shared';
import {
  BaseBreadcrumb,
  BaseLayout,
  FeatureGuard,
  TablePageSkeleton,
} from '@fly/shared-ui';

const DecisionRecords = lazy(() => import('./DecisionRecords'));

export const decisionRecordsRoutes: RouteObject[] = [
  {
    path: routes.DASHBOARD.DECISION_RECORDS,
    element: <BaseLayout />,
    handle: {
      Breadcrumb: BaseBreadcrumb,
    },
    children: [
      {
        index: true,
        element: (
          <FeatureGuard feature={FeatureToggle.DECISION_RECORDS}>
            <Suspense fallback={<TablePageSkeleton />}>
              <DecisionRecords />
            </Suspense>
          </FeatureGuard>
        ),
      },
    ],
  },
];
